import styled from 'styled-components';

export const ChecklistContainer = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 10px;
  min-width: 150px;

  @media (max-width: 768px) {
    min-width: 100%;
    padding-bottom: 8px;
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    padding-bottom: 6px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    gap: 8px;

    button {
      flex: 1;
      min-width: 120px;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;

    button {
      width: 100%;
      min-width: auto;
    }
  }
`;

export const PreviousHiredButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${props => props.theme.main.color};
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
  padding: 12px 16px;
  min-height: 44px;
  min-width: 44px;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    padding: 10px 14px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 10px 12px;
    width: 100%;
  }
`;
